<template>
  <div class="flex flex-row border-grey-100 rounded-md border-2 p-2 mt-1">
    <div class="text-sm">
      <div class="grid grid-cols-5 gap-7 p-2">
        <div>
          <div class="grid grid-cols-2 gap-2">
            <ValidationProvider :rules="`required`" name="low grade" v-slot="{ errors }">
              <SelectionField 
                v-model="formValues.lowGrade"
                :options="gradeList"
                :placeholder="'Low grade'"
                @input="updateValue('lowGrade', formValues.lowGrade)"
                :disabled="isAllGrades">
                Grade Range
              </SelectionField>
              <span
                class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                name="error-text">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
            <ValidationProvider :rules="`required|minGrade:${[formValues.lowGrade,formValues.highGrade]}`" name="high grade" v-slot="{ errors }">
              <SelectionField
                class="text-white"
                v-model="formValues.highGrade"
                :options="gradeList"
                :placeholder="'High grade'"
                @input="updateValue('highGrade', formValues.highGrade)"
                :disabled="isAllGrades">
                &nbsp;
              </SelectionField>
              <span
                class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                name="error-text">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
          <div class="inline-block">
            <label class="text-center block text-xs">
              <input type="checkbox" v-model="isAllGrades"/>
              All grades
            </label>
          </div>
        </div>
        <ValidationProvider :rules="`required`" name="event type" v-slot="{ errors }">
          <SelectionField
            v-model="formValues.eventType"
            :options="eventList"
            @input="updateValue('eventType', formValues.eventType)">
            Event Type
          </SelectionField>
          <span
            class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
            name="error-text">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
        <div v-if="formValues.eventType === 'ER' || formValues.eventType === 'LS'">
          <ValidationProvider :rules="`required`" name="time" v-slot="{ errors }">
            <div v-if="!isTimeDifference">
              <TimeField v-if="formValues.eventType === 'ER'"
                v-model="formValues.time"
                @input="updateValue('time', formValues.time)">
                Early Release Time
              </TimeField>
              <TimeField v-if="formValues.eventType === 'LS'"
                v-model="formValues.time"
                @input="updateValue('time', formValues.time)">
                Late Start Time
              </TimeField>
            </div>
            <div class="grid grid-cols-2 gap-2" v-if="isTimeDifference">
              <TextField
                class="-px-2 whitespace-nowrap"
                v-model="hours"
                :type="'number'"
                :placeholder="'HR'"
                :min="'0'"
                :max="'10'"
                @input="updateValue('timeDifference', formValues.timeDifference)">
                Time Difference
              </TextField>
              <TextField
                class="-pr-2"
                v-model="minutes"
                :type="'number'"
                :placeholder="'MIN'"
                :min="'0'"
                :max="'59'"
                @input="updateValue('timeDifference', formValues.timeDifference)">
                &nbsp;
              </TextField>
            </div>
            <span
                class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                name="error-text">
                {{ errors[0] }}
              </span>
          </ValidationProvider>
          <div class="inline-block">
            <label class="text-center block text-xs">
              <input type="checkbox" v-model="isTimeDifference"/>
              Submit time difference
            </label>
          </div>
        </div>
        <div>
          <ValidationProvider :rules="`required`" name="event date" v-slot="{ errors }">
            <CalendarField
              v-model="formValues.eventDate"
              @input="updateValue('eventDate', formValues.eventDate), changeDate()">
              {{ formValues.multipleDays ? 'First Day' : 'Event Date' }}
            </CalendarField>
            <span
              class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              name="error-text">
              {{ errors[0] }}
            </span>
          </ValidationProvider>
          <div class="inline-block">
            <label class="text-center block text-xs">
              <input type="checkbox" v-model="formValues.multipleDays"
                @input="toggleMultiple()"/>
              Does this event span multiple days?
            </label>
          </div>
        </div>
        <div v-if="formValues.multipleDays">
          <ValidationProvider :rules="`required|afterDate:${formValues.eventDate}`" name="last day" v-slot="{ errors }">
            <CalendarField 
              v-if="formValues.multipleDays"
              v-model="formValues.endDate"
              :min="formValues.eventDate"
              @input="updateValue('endDate', formValues.endDate)">
              Last Day
            </CalendarField>
            <span
              class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              name="error-text">
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>
        <!-- <ValidationProvider :rules="''" name="notes" v-slot="{ errors }">
          <TextArea
            :rows="1"
            v-model="formValues.notes"
            @input="updateValue('notes', formValues.notes)">
            Notes
          </TextArea>
          <span
            class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
            name="error-text">
            {{ errors[0] }}
          </span>
        </ValidationProvider> -->
      </div>
      
    </div>
    <button v-if="defaultValues==undefined"
      type="button" 
      class="basis-1 ml-3 my-auto " 
      @mouseover="hovering = true" 
      @mouseleave="hovering = false" 
      @click="onClick()">
      <svg v-if="!hovering" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#d1d5db" class="w-6 h-6" >
        <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm3 10.5a.75.75 0 000-1.5H9a.75.75 0 000 1.5h6z" clip-rule="evenodd" />
      </svg>
      <svg v-if="hovering" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#dc2626" class="w-6 h-6">
        <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd" />
      </svg>
    </button>
  </div>
</template>

<script>

import SelectionField from '../formComponents/SelectionField.vue'
import CalendarField from '../formComponents/CalendarField.vue'
import TimeField from '../formComponents/TimeField.vue'
import TextField from '../formComponents/TextField.vue'
// import TextArea from '../formComponents/TextArea.vue'

import DropdownLists from '../DropdownLists.json'

export default {
  components: {
    SelectionField,
    CalendarField,
    TimeField,
    // TextArea,
    TextField
  },
  data() {
    return {
      hovering: false,
      formValues: {
        multipleDays: false,
        notes: '',
      },
      eventList: DropdownLists.eventList,
      gradeList: DropdownLists.gradeList,
      isAllGrades: false,
      isTimeDifference: false,
      minutes: '0',
      hours: '0',
      today() {
        var today = new Date()
        var month = today.getMonth() + Number(1)
        if (month < 10) {
          month = '0' + month
        }
        var date = today.getDate()
        if (date < 10) {
          date = '0' + date
        }
        return today.getFullYear() + '-' + month + '-' + date
      },
    }
  },
  props: {
    defaultValues: undefined,
  },
  methods: {
    toggleMultiple(){
      this.formValues.multipleDays = !this.formValues.multipleDays
      if (!this.formValues.multipleDays) {
        this.formValues.endDate = ''
      }
      this.updateValue('multipleDays', this.formValues.multipleDays)
    },
    onClick() {
      this.$emit('remove')
    },
    updateValue(key, value) {
      this.$emit('input', { ...this.formValues, [key]: value })
    },
    changeDate() {
      this.$emit('changeDate')
    },
    setDefault() {
      if (this.defaultValues) {
        this.formValues.eventDate = this.defaultValues.event_date
        this.formValues.lowGrade = this.defaultValues.low_grade
        this.formValues.highGrade = this.defaultValues.high_grade
        this.formValues.eventType = this.defaultValues.event_type
        if (this.isERorLS()) {
          this.$forceUpdate()
        }
        this.formValues.time = this.defaultValues.time
        this.formValues.notes = this.defaultValues.notes
        this.formValues.timeDifference = this.defaultValues.time_difference
        if (this.formValues.timeDifference) {
          this.isTimeDifference = true
          this.hours = Math.floor(this.formValues.timeDifference / 60)
          this.minutes = this.formValues.timeDifference % 60
          this.$forceUpdate()
        }
      }
    },
    isERorLS() {
      let type = this.formValues.eventType
      return type === 'ER' || type === 'LS'
    },
  },
  computed: {
    models: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
  },
  mounted() {
    this.setDefault()
  },
  watch: {
    isTimeDifference(value) {
      if (!value) {
        this.formValues.timeDifference = ''
      }
    },
    hours: function () {
      this.formValues.timeDifference =  Number(this.hours) * 60 + Number(this.minutes)
    },
    minutes: function () {
      this.formValues.timeDifference =  Number(this.hours) * 60 + Number(this.minutes)
    },
    isAllGrades: function (value) {
      if (value) {
        this.formValues.highGrade = '130'
        this.formValues.lowGrade = '1'
      }
    }
  }
}
</script>